export default "__VITE_ASSET__CROyjGhI__"